import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Moment } from 'moment';

import { environment } from '@environments/environment';
import { UrlComponentHttpParamEncoder } from '@platform/shared/http/url-component-http-param-encoder';

@Injectable({
  providedIn: 'root',
})
export class ReportService {
  constructor(private http: HttpClient) {}

  public getCustomerSpaceReport(): Observable<Blob> {
    return this.http.get(`${environment.apiUrl}/reports/customer-spaces`, { responseType: 'blob' });
  }

  public getProjectReport(): Observable<Blob> {
    return this.http.get(`${environment.apiUrl}/reports/projects`, { responseType: 'blob' });
  }

  public getUserReport(): Observable<Blob> {
    return this.http.get(`${environment.apiUrl}/reports/users`, { responseType: 'blob' });
  }

  public getChargingReport(periodStartDate: Moment, periodEndDate: Moment): Observable<Blob> {
    const params = new HttpParams({ encoder: new UrlComponentHttpParamEncoder() })
      .set('periodStartDate', periodStartDate.format('YYYY-MM-DD'))
      .set('periodEndDate', periodEndDate.format('YYYY-MM-DD'));

    return this.http.get(`${environment.apiUrl}/reports/charging`, { params, responseType: 'blob' });
  }

  public getFileProcessReport(): Observable<Blob> {
    return this.http.get(`${environment.apiUrl}/reports/file-process`, { responseType: 'blob' });
  }
}
